<template>
    <div class="panel">
		<div style="display: flex;">
			<div style="flex: 1;">
				<div style="padding-left: 5px; padding-right: 5px;">
				    <div style="background: #f5f5f5;margin-top: 3px">
				        <table style="width: 100%;">
				            <tr>
				                <td align="center">
				                    <h2>{{sjdata.paperMap.sjmc || ''}}</h2>
				                </td>
				            </tr>
				            <tr>
				                <td align="center" style="font-size:12px;">
				                    <h5 style="margin-top: 1px;"><b>普通试卷</b>&nbsp;&nbsp;考生试卷相同</h5>
				                </td>
				            </tr>
				            <tr>
				                <td align="center" style="font-size:12px;">
				                    <h5 style="margin-top: 1px;"><b>时间设定</b>:{{sjdata.paperMap.kksj || ''}} -- {{sjdata.paperMap.jssj || ''}}</h5>
				                </td>
				            </tr>
				            <tr>
				                <td align="center">
				                    卷面总分:<label class="form-inline"><input readonly id="paper_jmzf" type="text" class="form-control" style="width: 40px;height:28px"/></label>&nbsp;&nbsp;及格分数<label class="form-inline"><input class="form-control" id="paper_jgfs" type="text"  style="width: 40px;height: 28px;"/></label>
				                </td>
				            </tr>
				        </table>
				    </div>
				    <div style="margin-top:15px">
				        <button type="button" @click="addBigQues" class="btn btn-primary btn-sm">添加大题</button>
				        <button type="button"  @click="expandAll" class="btn btn-primary btn-sm" style="margin-left: 10px">全部展开</button>
				        <button type="button" @click="unExpandAll" class="btn btn-primary btn-sm" style="margin-left: 10px">全部收缩</button>
				    </div>
				    <div class="panel-group" id="question_sections">
				        <!--大题模板-->
				        <div  style="margin-top:25px" :sectionid="questionSection.id" class="question_section_wrapper panel panel-default" v-for="(questionSection, index) in questionSectionList" :key="'ques_section_'+questionSection.id">
				            <div class="panel-heading">
				                <div style="font-size: 15px;font-weight: 900;">
				                    第<span class="big_number_txt">{{index+1}}</span>大题、<input :id="questionSection.id+'_title'" type="text" style="width: 200px" placeholder="请输入大题名称"/>&nbsp;&nbsp;每题&nbsp;<input :id="questionSection.id+'_score'" type="text" style="width: 40px" @input="refreshJmzf"/>&nbsp;分
				                    <a @click="toggleExpand(questionSection)" class="pull-right" style="margin-right: 50px" role="button" data-toggle="collapse" aria-expanded="true">
				                        <span style="font-size: 20px"><i class="fa" :class="{'fa-arrow-down':questionSection.expand,'fa-arrow-up':!questionSection.expand}" aria-hidden="true"></i></span>
				                    </a>
				                    <span @click="removeBig(questionSection,index)" v-if="index>0" style="color: red;font-size: 21px;margin-right: -70px;cursor: pointer" class="pull-right"><i class="fa fa-times" aria-hidden="true"></i></span>
				                </div>
				            </div>
				            <div class="panel-collapse collapse" :class="{'in':questionSection.expand}">
				                <div class="panel-body">
				                    <ul class="list-group" :id="'subquestions'+questionSection.id" style="min-height: 70px">

				                    </ul>
				                </div>
				            </div>
				        </div>
				    </div>
				</div>
				<div style="text-align: center;">
					<button type="button" class="btn btn-primary" @click="save" style="margin-bottom: 20px;">提交</button>
				</div>
			</div>

			<div style="flex-basis: 258px;">
				<div style="padding-left: 10px;">
					<div class="panel panel-primary" style="top: 120px;position: fixed;width:255px;height: calc(100vh - 126px);right: 5px;">
				        <div class="panel-heading">
				            <i class="fa fa-search" aria-hidden="true"></i>试题检索
				        </div>
				        <div class="panel-body">
				            <div class="row">
				                <div class="col-sm-12">
									 <form role="form" id="user_add_form">
										 <div class="form-group">
											<BootstrapCombobox
											    :data="kcList" text-field="kcmc" value-field="id" v-model="query.kcId"
												:format-option="showKcOption" placeholder="-课程筛选-">
											</BootstrapCombobox>
										 </div>
										 <div class="form-group">
											  <BootstrapCombobox
											      :data="tkList" text-field="tkmc" value-field="id" v-model="query.tkId"
											  	placeholder="-题库筛选-">
											  </BootstrapCombobox>
										  </div>
										 <div class="form-group">
											 <select  v-model="query.stlb"  class="form-control">
											     <option value="">-选择题型-</option>
											     <option v-for="stlb in stlbList" :key="stlb.value" :value="stlb.value">{{stlb.text}}</option>
											 </select>
										 </div>
										 <div class="form-group">
											 <select  v-model="query.stnd"  class="form-control">
											     <option value="">-选择难度-</option>
											     <option v-for="stlb in stndList" :key="stlb.value" :value="stlb.value">{{stlb.text}}</option>
											 </select>
										 </div>
										 <div class="text-center">
										     <button @click="seachshiti"  type="button" class="btn btn-sm btn-primary"><i class="fa fa-search" aria-hidden="true"></i>搜索</button>
										 </div>
									 </form>
									 <div style="height: calc(100vh - 426px);">
										 <!-- 试题选择区域 -->
										 <ul class="list-group" id="ques_choose_area" style="overflow-y: scroll;overflow-x: hidden;height: 100%">

										 </ul>
									 </div>
				                </div>
				            </div>
				        </div>
				    </div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>

    /**
     * 平时作业-试卷配置
     */

    import tableMixin from '@/mixins/table.js';  //表格
    import $ from 'jquery';
    import Sortable from 'sortablejs';
    import utils from "@/plugins/utils.js";


    export default {
        mixins: [tableMixin],
        name:"HomeworkPaperPeizhi",
        data:function(){
            return {
                paperId:this.$route.query['paper_id'],
                sortableLeft:null,
                sortableRight:null,
                questionSectionIdList:[],
                questionSectionList:[],//大题集合
                tkList:[],//题库列表
                kcList:[],//课程列表
                stndList:[],//试题难度
                questionList:[
                ],
                query:{
                    kcId:'',
                    tkId:'',
                    stlb:'',
                    stnd:''
                },
				sjdata: {
					paperMap: {},
					paper: {}
				},
                stlbList:[],
				stlbMap:{
					'SINGLECHOICE':'单选题',
					'MULTIPLECHOICE':'多选题',
					'JUDGMENT':'判断题',
					'BLANKFILL':'填空题',
					'ESSAY':'问答题',
					'MCJST':'名词解释题',
					'LST':'论述题',
					'JDT':'简答题',
					'TT':'套题'
				}
            }
        },
        mounted(){
			this.getPaper();
        },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'自学考试'},{name:'试卷管理'},{name:'平时作业'},{name:'试卷配置'}]);
			this.$store.commit('setShowReturnBackBtn',true);
            this.stndList = [{value: 'FCRY', text: '非常容易'}, {value: 'BJRY', text: '比较容易'}, {value: 'CG', text: '常规'}, {value: 'JN', text: '较难'}, {value: 'FCN', text: '非常难'}];//试题难度
            this.stlbList = [{value: 'SINGLECHOICE', text: '单选题'}, {value: 'MULTIPLECHOICE', text: '多选题'}, {value: 'JUDGMENT', text: '判断题'}, {value: 'BLANKFILL', text: '填空题'}, {value: 'ESSAY', text: '问答题'}, {value: 'MCJST', text: '名词解释题'}, {value: 'LST', text: '论述题'}, {value: 'JDT', text: '简答题'}, {value: 'TT', text: '套题'}];//试题类别
            this.getkcList();
        },
        watch: {
            'query.kcId':function(){
                this.getTkList();
            }
        },
        methods: {
			initSortable:function(){
				let question_sections = document.getElementById("question_sections");
				this.sortableLeft = new Sortable(question_sections, {
				    group: {
				        name: 'bigQuestion'
				    },
				    onSort:(evt)=>{
				       $('.question_section_wrapper').each(function(indexb,itmeb){
				           $(this).find('.big_number_txt').html('<strong>'+(indexb+1)+'</strong>');
				       });
				    },
				    animation: 250
				});
				//init subquestionlist
				this.initSubQuestionSortale();
				let ques_choose_area = document.getElementById("ques_choose_area");
				this.sortableRight = new Sortable(ques_choose_area, {
				    group: {
				        name: 'selectQuestion'
				    },
				    animation: 250,
				    onAdd:(evt)=>{
				        evt.item.setAttribute('class','list-group-item unselected_ques');
				        $("#ques_choose_area").find('.list-group-item').find('.tihao_text').remove();
				        $("#ques_choose_area").find('.list-group-item').find('.del_btn').remove();
				    }
				});
			},
			getPaper:function(){
				this.$http.post('/htgl/biz/zypx/sj/pszy/xq',{sjId:this.paperId}).then(res=>{
					if (res.data) {
						this.sjdata = res.data;
						this.sjdata.paperMap = this.sjdata.paperMap || {};
						this.sjdata.paper = this.sjdata.paper || {};
						if(!res.data.paper || !res.data.paper.sections ||
									res.data.paper.sections.length==0) {
							let sectionid = 'section_'+ utils.guid();
							this.questionSectionIdList.push(sectionid);
							this.questionSectionList.push({id:sectionid, expand:true});
							//init sortable
							this.$nextTick(()=>{
								this.initSortable();
							});
						}
						else{
							let _this = this;
							this.sjdata.paper.sections.forEach(s=>{
								let sid = 'section_'+ utils.guid();
								_this.questionSectionIdList.push(sid);
								_this.questionSectionList.push({id:sid, expand:true});
							});
							this.$nextTick(()=>{
								//dom render
								$("#paper_jmzf").val(this.sjdata.paper.jmzf);
								$("#paper_jgfs").val(this.sjdata.paper.jgf);
								this.sjdata.paper.sections.forEach((x,indexg) => {
									//渲染大题
									let sectionid = _this.questionSectionIdList[indexg];
									let questions =  x.questions || [];
									//渲染大题标题以及每小题分数
									$('.question_section_wrapper').each(function(indexb,itmeb){
										let remark = x.remark || '';
										let score = x.rscore || '';
										$(this).find('#'+sectionid+'_title').val(remark);
										$(this).find('#'+sectionid+'_score').val(score);
									});
									//渲染小题
									questions.forEach(q=>{
										let $li = $('<li bind_ques_id="'+q.id+'" class="list-group-item selected_ques" id="quesid_'+q.id+(utils.guid())+'_randomkey">');
										$li.html(q.sttg);
										$li.find('p:eq(0)').prepend('【'+(_this.stlbMap[q.stlb] || '')+'】');
										//套题处理
										if(q.stlb == 'TT'){
											let $chilren = $('<ul class="list-group tt_children" style="margin-right:7px;font-size:9pt"></ul>');
											q.children.forEach((y,indexz)=>{
												let $child = $('<li class="list-group-item tt_child" style="padding-top:8px;padding-bottom:0px"></li>');
												$child.attr('ques_id',y.id);
												let child_num = '('+(indexz+1)+')、';
												$child.html(y.sttg);
												$child.find('p').prepend(child_num);
												//插入分数输入框
												let $score_input = $('<input class="tt_child_score" style="width:40px">');
												let stfz = y.stfz || '';
												$score_input.val(stfz);
												$child.find('p').append($score_input);
												$child.find('p').append('<span class="tt_child_tip">分</span>');
												$chilren.append($child);
											});
											$li.append($chilren);
										}
										$("#subquestions"+sectionid).append($li);
										let domlist = $('#subquestions'+sectionid).find('.list-group-item').not('.tt_child');
										domlist.each(function(indexa, itema){
											$(this).find('.tihao_text').remove();
											$(this).find('.del_btn').remove();
											let $tihaoHtml = $('<span class="tihao_text">'+(indexa+1)+'、</span>');
											let $delbtnHtml =$('<span class="del_btn pull-right" style="color:red;font-size:20px;margin-right:20px;cursor:pointer"><i class="fa fa-times" aria-hidden="true"></i></span>');
											$(this).find('p').first().prepend($tihaoHtml);
											$(this).find('p').first().append($delbtnHtml);
											let selectedQues = $(this);
											let selectedQuesWrapper = $(this).parent();
											$delbtnHtml.click(function(){
												selectedQues.remove();
												selectedQuesWrapper.find('.selected_ques').each(function(indexf,itemf){
													$(this).find('.tihao_text').html((indexf+1)+'、');
												});
												_this.refreshJmzf();
											});
										});
									});
								});
								//init sortable
								this.initSortable();
							});
						}
					}
				});
			},
			showKcOption:function(item){
				return item.kcdm+'-'+item.kcmc;
			},
            refreshJmzf:function(){//刷新卷面总分
                let totalScore = 0;
                $('.question_section_wrapper').each(function(indexz,itemz){
                    let sectionid = $(this).attr('sectionid');
                    let eachScore = $('#'+sectionid+'_score').val() || 0;
                    totalScore += $(this).find('.selected_ques').length*parseInt(eachScore);
                });
                $("#paper_jmzf").val(totalScore);
                $("#paper_jgfs").val(Math.round(totalScore*0.6*10)/10);
            },
            //获取课程
            getkcList:function(){
                this.$http.post('/htgl/biz/zypx/sj/pszy/hqAllZypxkc').then(res=>{
                    if(res.data){
                        this.kcList = res.data || [];
                    }
                });
            },
            getTkList:function(){
                this.$http.post('/htgl/biz/zypx/sj/pszy/hqtk',{kcId:this.query.kcId}).then(res=>{
                    if(res.data){
                        this.tkList = res.data || [];
                    }
                });
            },
            seachshiti:function(){
				let _this = this;
                this.$http.post('/htgl/biz/zypx/sj/pszy/cxst',this.query).then(res=>{
                    if(res.data && res.data.list){
                        this.questionList = res.data.list || [];
                        $("#ques_choose_area").empty();
                        this.questionList.forEach(x=>{
							//套题的展示
							if(x.stlb == 'TT'){
								let $li = $('<li bind_ques_id="'+x.id+'" class="list-group-item unselected_ques" id="quesid_'+x.id+(new Date().getTime())+'_randomkey">');
								$li.html(x.sttg);
								if(x.childrens && x.childrens.length>0){
									let $chilren = $('<ul class="list-group tt_children" style="margin-right:7px;font-size:9pt"></ul>');
									x.childrens.forEach((y,index)=>{
										let $child = $('<li class="list-group-item tt_child" style="padding-top:8px;padding-bottom:0px"></li>');
										$child.attr('ques_id',y.id);
										let child_num = '('+(index+1)+')、';
										$child.html(y.sttg);
										$child.find('p').prepend(child_num);
										//插入分数输入框
										let $score_input = $('<input class="tt_child_score" style="width:40px">');
										$child.find('p').append($score_input);
										$child.find('p').append('<span class="tt_child_tip">分</span>');
										$chilren.append($child);
									});
									$li.append($chilren);
								}
								$li.find('p:eq(0)').prepend('【'+(_this.stlbMap[x.stlb] || '')+'】');
								$("#ques_choose_area").append($li);
							}
							else{
								let $li = $('<li bind_ques_id="'+x.id+'" class="list-group-item unselected_ques" id="quesid_'+x.id+(new Date().getTime())+'_randomkey">');
								$li.html(x.sttg);
								$li.find('p:eq(0)').prepend('【'+(_this.stlbMap[x.stlb] || '')+'】');
								$("#ques_choose_area").append($li);
							}
                        })
                    }
                });
            },
            removeBig:function(questionSection,index){
                if(questionSection.sortable){
                    questionSection.sortable.destroy();
                }
                this.questionSectionList.splice(index,1);
                this.$nextTick(()=>{
                    this.refreshJmzf();
                });
            },
            save:function(){
				let _this = this;
				this.refreshJmzf();
				let params = {};
				params.id = this.paperId;
				if(!params.id){
				    this.$error('缺失试卷ID');
				    return;
				}
				let jmzf = $('#paper_jmzf').val();
				if(!jmzf){
				    this.$error('卷面总分不能够为空');
				    return;
				}
				let jgfs = $('#paper_jgfs').val();
				if(!jgfs){
				    this.$error('请输入及格分数');
				    return;
				}
				params.jmzf = jmzf;
				params.jgfs = jgfs;
				let questionContainer = $('#question_sections');
				let question_section_wrapper = questionContainer.find('.question_section_wrapper');
				let submitQuestionList = [];
				let passed = true;
				let errorMsg = [];
                question_section_wrapper.each(function(indexc, itemc){
                    let sectionId = $(this).attr('sectionid');
                    let sectionObj = {};
                    sectionObj.title = $("#"+sectionId+'_title').val();
                    if(!sectionObj.title){
                        errorMsg.push('第'+(indexc+1)+'大题请输入大题名称');
                        passed = false;
                        return false;
                    }
                    sectionObj.score = $("#"+sectionId+'_score').val();
                    if(!sectionObj.score){
                        errorMsg.push('第'+(indexc+1)+'大题请输入大题中每一个小题的分数');
                        passed = false;
                        return false;
                    }
                    //获取小题ID
                    let questionIds = [];
                    $(this).find('.selected_ques').each(function(indexd,itemd){
                        questionIds.push($(this).attr('bind_ques_id'));
                    });
                    if(questionIds.length == 0){
                        errorMsg.push('第'+(indexc+1)+'大题中没有小题,请添加小题');
                        passed = false;
                        return false;
                    }
                    sectionObj.questionIds = questionIds;
					//判断大题中是否包含套题，如果有套题 则需要传入套题中每一个小题对应的分数
					if($(this).find('.tt_children').length>0){
						let subQuesScore = {};
						//一个套题 校验一次分数是否等于每一大题的分数
						$(this).find('.tt_children').each(function(indexi,itemi){
							if($(this).find('.tt_child').length>0){
								let tt_total_score = 0;
								$(this).find('.tt_child').each(function(indexf,itemf){
									let tt_child_ques_id = $(this).attr('ques_id');
									let tt_child_ques_score = $(this).find('.tt_child_score').val();
									if(!tt_child_ques_score){
										let child_sttg = $(this).find('p').contents().filter(function() {
											return this.nodeType === 3;
										}).text();
										errorMsg.push('第'+(indexc+1)+'大题中有套题的小题未赋分【小题题干:“'+child_sttg+'”】，请先赋分再提交');
										passed = false;
										return false;
									}
									else{
										tt_total_score  = tt_total_score + Number(tt_child_ques_score);
										subQuesScore[tt_child_ques_id] = tt_child_ques_score;
									}
								});
								if(tt_total_score != sectionObj.score){
									errorMsg.push('第'+(indexc+1)+'大题中第'+(indexi+1)+'个套题下的每小题分数和不等于该大题设置的每一题分数，请重新赋分再提交');
									passed = false;
									return false;
								}
							}
						});
						sectionObj.subQuesScore = subQuesScore;
					}
                    submitQuestionList.push(sectionObj);
                });
                if(!passed){
					this.$error(errorMsg.join('<br>'));
                    return;
                }
                params.questionList = submitQuestionList;
                this.$http.post('/htgl/biz/zypx/sj/pszy/pz',JSON.stringify(params),{'Content-Type':'application/json;charset=UTF-8'}).then(res=>{
                    if(res.data==true){
                        this.$success('操作成功',()=>{
                            this.$router.push({name:'HomeworkPaperList'})
                        })
                    }
                });
            },
            initSubQuestionSortale:function(){
                let _this = this;
                this.questionSectionList.forEach(bigQues=>{
                    if(!bigQues.sortable){
                        let subdom = document.getElementById("subquestions"+bigQues.id);
                        let subquesSortable = new Sortable(subdom, {
                            group: {
                                name: 'selectQuestion'
                            },
                            onAdd:(evt)=>{
                                evt.item.setAttribute('class','list-group-item selected_ques');
                                _this.refreshJmzf();
                            },
                            onSort:(evt)=>{
                                let domlist = $('#subquestions'+bigQues.id).find('.list-group-item').not('.tt_child');
                                domlist.each(function(indexa, itema){
                                    $(this).find('.tihao_text').remove();
                                    $(this).find('.del_btn').remove();
                                    let $tihaoHtml = $('<span class="tihao_text">'+(indexa+1)+'、</span>');
                                    let $delbtnHtml =$('<span class="del_btn pull-right" style="color:red;font-size:20px;margin-right:20px;cursor:pointer"><i class="fa fa-times" aria-hidden="true"></i></span>');
                                    $(this).find('p').first().prepend($tihaoHtml);
                                    $(this).find('p').first().append($delbtnHtml);
                                    let selectedQues = $(this);
                                    let selectedQuesWrapper = $(this).parent();
                                    $delbtnHtml.click(function(){
                                        selectedQues.remove();
                                        selectedQuesWrapper.find('.selected_ques').each(function(indexf,itemf){
                                            $(this).find('.tihao_text').html((indexf+1)+'、');
                                        });
                                        _this.refreshJmzf();
                                    });

                                });
                            },
                            animation: 250
                        });
                        bigQues.sortable = subquesSortable;
                    }
                });
            },
            toggleExpand:function(item){
                if(item.expand){
                    item.expand = false;
                }
                else{
                    item.expand = true;
                }
            },
            addBigQues:function(){
                let randomId = 'section_'+ utils.guid();
                if(this.questionSectionIdList.indexOf(randomId) > -1){
                    this.$error('生成大题ID错误');
                    return;
                }
				else{
					this.questionSectionIdList.push(randomId);
					this.questionSectionList.push({id:randomId,expand:true});
					this.$nextTick(() => {
					    this.initSubQuestionSortale();
					})
				}
            },
            expandAll:function(){
                this.questionSectionList.forEach(item=>{
                    item.expand = true;
                })
            },
            unExpandAll:function(){
                this.questionSectionList.forEach(item=>{
                    item.expand = false;
                })
            }
        },
        beforeDestroy:function(){
            if(this.sortableLeft){
                this.sortableLeft.destroy();
            }
            if(this.questionSectionList){
                this.questionSectionList.forEach(item=>{
                    if(item.sortable){
                        item.sortable.destroy();
                    }
                })
            }
            if(this.sortableRight){
                this.sortableRight.destroy();
            }
        }

    }
</script>
<style scoped>
</style>
